import { captureMessage } from '@sentry/nextjs';

export const SDK_KEY = 'soundxyz-sdk';

const MINIMUM_GAS_EXPECTED = 100_000n;
const FALLBACK_GAS = 500_000n;

/**
 * When getting a gasEstimate, the transaction is simulated by the node, and a value for how much gas is required is returned.
 * If the transaction is invalid, or would fail, the call throws.
 * Weird behavior we learned, is that if the transaction is for a contract on one chain, but the wrong chain is use, it defaults to a “Transfer transaction”
 * The estimate then comes in as a valid value, but for the cost of a Transfer (which is insufficient gas for the operation on the right chain)
 * For extra caution, if we ever get a low estimate, we override with a high gas limit
 */
export function expectNormalGas({
  estimation,
  editionAddress,
  chainId,
  quantity,
  loggingExtra,
}: {
  estimation: bigint;
  editionAddress: string;
  chainId: number;
  quantity: number;
  loggingExtra?: Record<string, unknown>;
}) {
  if (estimation < MINIMUM_GAS_EXPECTED) {
    captureMessage('Unexpected estimation received', {
      tags: {
        chainId,
        editionAddress,
      },
      extra: {
        ...loggingExtra,
        estimation: estimation.toString(),
        quantity,
      },
      level: 'warning',
    });
    return FALLBACK_GAS;
  }

  return estimation;
}
